import React from 'react';
import '../styles/legal-pages.css';
import { FaMoon, FaSun } from 'react-icons/fa';

function TermsOfUse({ theme, onToggleTheme, onNavigateToLanding }) {
    return (
        <div className="legal-page">
            {/* Header */}
            <header className="legal-header">
                <div className="legal-header-content">
                    <div className="legal-logo">
                        <img src="/orb_dark.png" alt="TeachingOrb icon" width="20" height="20" />
                        <span 
                            style={{ fontFamily: 'Sentient, sans-serif', cursor: 'pointer' }}
                            onClick={onNavigateToLanding}
                        >
                            TeachingOrb
                        </span>
                    </div>
                    <div className="legal-header-actions">
                        {/* Theme toggle button - disabled for now */}
                        {/* {onToggleTheme && (
                            <button className="legal-theme-toggle-btn" onClick={onToggleTheme}>
                                {theme === 'light' ? <FaMoon /> : <FaSun />}
                            </button>
                        )} */}
                        <button 
                            className="legal-back-btn"
                            onClick={onNavigateToLanding}
                        >
                            Back
                        </button>
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <main className="legal-main">
                <div className="legal-container">
                    <section className="legal-section">
                        <h1 className="legal-title">Terms of Use</h1>
                        <p className="legal-last-updated">Last updated: November 2024</p>

                        <article className="legal-article">
                            <h2 className="legal-heading">1. Agreement to Terms</h2>
                            <p>
                                By accessing and using the TeachingOrb platform (the "Service"), you agree to be bound by these Terms of Use. If you do not agree to abide by the above, please do not use this service.
                            </p>
                        </article>

                        <article className="legal-article">
                            <h2 className="legal-heading">2. Use License</h2>
                            <p>
                                Permission is granted to temporarily download one copy of the materials (information or software) on TeachingOrb for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
                            </p>
                            <ul className="legal-list">
                                <li>Modify or copy the materials</li>
                                <li>Use the materials for any commercial purpose or for any public display</li>
                                <li>Attempt to decompile or reverse engineer any software contained on TeachingOrb</li>
                                <li>Remove any copyright or other proprietary notations from the materials</li>
                                <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
                                <li>Violate any applicable laws or regulations</li>
                                <li>Harass, abuse, or threaten other users</li>
                                <li>Submit false or misleading information</li>
                            </ul>
                        </article>

                        <article className="legal-article">
                            <h2 className="legal-heading">3. Disclaimer</h2>
                            <p>
                                The materials on TeachingOrb are provided on an 'as is' basis. TeachingOrb makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
                            </p>
                        </article>

                        <article className="legal-article">
                            <h2 className="legal-heading">4. Limitations</h2>
                            <p>
                                In no event shall TeachingOrb or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on TeachingOrb, even if TeachingOrb or a TeachingOrb authorized representative has been notified orally or in writing of the possibility of such damage.
                            </p>
                        </article>

                        <article className="legal-article">
                            <h2 className="legal-heading">5. Accuracy of Materials</h2>
                            <p>
                                The materials appearing on TeachingOrb could include technical, typographical, or photographic errors. TeachingOrb does not warrant that any of the materials on its Website are accurate, complete, or current. TeachingOrb may make changes to the materials contained on its Website at any time without notice.
                            </p>
                        </article>

                        <article className="legal-article">
                            <h2 className="legal-heading">6. Links</h2>
                            <p>
                                TeachingOrb has not reviewed all of the sites linked to its Website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by TeachingOrb of the site. Use of any such linked website is at the user's own risk.
                            </p>
                        </article>

                        <article className="legal-article">
                            <h2 className="legal-heading">7. Modifications</h2>
                            <p>
                                TeachingOrb may revise these terms of use for its Website at any time without notice. By using this Website, you are agreeing to be bound by the then current version of these terms of use.
                            </p>
                        </article>

                        <article className="legal-article">
                            <h2 className="legal-heading">8. Governing Law</h2>
                            <p>
                                These terms and conditions are governed by and construed in accordance with the laws of the jurisdiction in which TeachingOrb operates, and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
                            </p>
                        </article>

                        <article className="legal-article">
                            <h2 className="legal-heading">9. User Accounts</h2>
                            <p>
                                When you create an account on TeachingOrb, you are responsible for maintaining the confidentiality of your account information and password. You agree to accept responsibility for all activities that occur under your account. You must notify us immediately of any unauthorized use of your account.
                            </p>
                        </article>

                        <article className="legal-article">
                            <h2 className="legal-heading">10. Course Content</h2>
                            <p>
                                TeachingOrb generates educational content using artificial intelligence. While we strive for accuracy, users should independently verify critical information. The courses provided are for educational purposes only and should not be considered professional advice in specific domains.
                            </p>
                        </article>

                        <article className="legal-article">
                            <h2 className="legal-heading">11. Intellectual Property Rights</h2>
                            <p>
                                Unless otherwise stated, TeachingOrb and/or its licensors own the intellectual property rights for all material on TeachingOrb. All intellectual property rights are reserved. You may access this from TeachingOrb for your personal use subjected to restrictions set in these terms and conditions.
                            </p>
                            <p>
                                You must not:
                            </p>
                            <ul className="legal-list">
                                <li>Republish material from TeachingOrb without proper attribution</li>
                                <li>Sell, rent or sub-license material from the Website</li>
                                <li>Reproduce, duplicate or copy material from this Website for commercial purposes</li>
                                <li>Redistribute content from TeachingOrb unless content is specifically made for redistribution</li>
                            </ul>
                        </article>

                        <article className="legal-article">
                            <h2 className="legal-heading">12. User-Generated Content</h2>
                            <p>
                                Any content you submit, post, or display on TeachingOrb should not contain illegal content or infringe on intellectual property rights. By submitting content, you grant TeachingOrb a worldwide, non-exclusive, royalty-free license to use, reproduce, adapt, publish, and distribute it in any media.
                            </p>
                        </article>

                        <article className="legal-article">
                            <h2 className="legal-heading">13. Limitation of Liability</h2>
                            <p>
                                To the fullest extent allowed by law, TeachingOrb shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the Service, even if TeachingOrb has been advised of the possibility of such damages.
                            </p>
                        </article>

                        <article className="legal-article">
                            <h2 className="legal-heading">14. Termination</h2>
                            <p>
                                TeachingOrb may terminate or suspend your account and access to the Service immediately, without prior notice or liability, if you breach any provision of these Terms. You may terminate your account at any time by requesting deletion through your account settings.
                            </p>
                        </article>

                        <article className="legal-article">
                            <h2 className="legal-heading">15. Contact Information</h2>
                            <p>
                                If you have any questions about these Terms of Use, please contact us at support@teachingorb.com or through the support page on our Website.
                            </p>
                            <p>
                                TeachingOrb is a service offered by:<br />
                                <strong>Kilowatt Engineering and Design, Inc.</strong>
                            </p>
                        </article>
                    </section>
                </div>
            </main>

            {/* Footer */}
            <footer className="legal-footer">
                <div className="legal-footer-content">
                    <p>&copy; 2025 TeachingOrb. A service offered by Kilowatt Engineering and Design, Inc. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
}

export default TermsOfUse;

